/**
 * @fileoverview Redirect shown at "/" and for any unmatched path.
 * @description Sends signed-out visitors to /login and signed-in visitors to their resolved
 * destination (see `resolveSignedInDestination` — privilege-dependent, since Sales and Banking are
 * separate modules, and /change-password instead for a user who still must change their
 * password), so there's never a blank page at the site root.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import { Navigate } from 'react-router'

import { ROUTES } from '@/shared/constants/routes.constants'
import { resolveSignedInDestination } from '@/shared/lib/auth/resolve-home-route'
import { useAuth } from '@/shared/lib/auth/useAuth'

/**
 * @component
 */
function RootRedirect() {
  const { isAuthenticated, user } = useAuth()
  const target = isAuthenticated ? resolveSignedInDestination(user) : ROUTES.LOGIN

  return <Navigate to={target} replace />
}

export default RootRedirect
